// import React from "react";

// const Dropdown = (props) => {
//   return (
//     <select
//       id={props.id}
//       value={props.selectoption}
//       onClick={props.onClick}
//       onChange={props.onChange}
//       className={props.className}
//     >
//       {props.Displayname && <option value="">{props.Displayname}</option>}
//       {props.options.map((option, index) => (
//         <option key={index} value={option}>
//           {option}
//         </option>
//       ))}
//     </select>
//   );
// };
// export default Dropdown;

import React from "react";

const Dropdown = (props) => {
  return (
    <>
      {props.labelname}
      <select
        value={props.selectoption}
        onClick={props.onClick}
        onChange={props.onChange}
        className={props.className}
        disabled={props.disabled}
        name={props.Name}
      >
        {props.Displayname && <option value="">{props.Displayname}</option>}
        {props.options?.length > 0 ? (
          props.options.map((option, index) => (
            <option key={index} value={option}>
              {option}
            </option>
          ))
        ) : (
          <option value="">No Options Avaliable</option>
        )}
      </select>
    </>
  );
};
export default Dropdown;
